import { get } from 'lodash';
import * as Yup from 'yup';
import { formatParticipationRate } from 'helpers/format-string';

export const columns = [
  { field: 'id', headerName: 'ID', width: 90 },
  { field: 'name', headerName: 'Name', width: 250 },
  {
    field: 'organizationName',
    headerName: 'Organization',
    width: 250,
  },
  { field: 'clinics_number', headerName: 'Clinics', width: 120 },
  { field: 'slots', headerName: 'Slots', width: 120 },
  { field: 'booked', headerName: 'Booked', width: 130 },
  {
    field: 'rate_participation',
    headerName: '% Participation',
    width: 250,
    valueFormatter: ({ value }) => formatParticipationRate(value),
  },
];

export const suggestionPrimaryKey = 'name';
export const suggestionSecondaryKeys = ['organizationName'];

export const initialValues = (scheduler) => ({
  name: get(scheduler, 'name', ''),
  organizationId: get(scheduler, 'organization_id', ''),
  showBirthDate: get(scheduler, 'show_birth_date', false),
  customField: get(scheduler, 'custom_field', ''),
});

export const validationSchema = Yup.object().shape({
  name: Yup.string().required('field is required'),
  organizationId: Yup.number().required('field is required'),
  showBirthDate: Yup.boolean().required('field is required'),
  customField: Yup.string(),
});
